import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.FETCH_VIOLATE_REASONS.REQUEST, saga.fetchViolateReasons);
}
